import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { TimelineTrackerService } from '../services/dev-tool/timeline-tracker.service';
import { DebugLoggerService } from '../services/dev-tool/debug-logger.service';

export const timelineHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const timelineService = inject(TimelineTrackerService);
  const loggerService = inject(DebugLoggerService);

  const startTime = Date.now();
  const method = req.method;
  const url = req.url;

  return next(req).pipe(
    tap(event => {
      if (event.type === 4) { // HttpEventType.Response
        const duration = Date.now() - startTime;
        const response = event as any;
        const status = response.status;

        // Handle blob responses (images, files) - convert to metadata + preview
        let responseBody = response.body;
        if (response.body instanceof Blob) {
          const blob = response.body;
          const bytes = blob.size;
          const sizeFormatted = bytes < 1024 ? `${bytes} B`
            : bytes < 1024 * 1024 ? `${(bytes / 1024).toFixed(1)} KB`
            : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

          responseBody = {
            _isBlob: true,
            type: blob.type,
            size: bytes,
            sizeFormatted,
            ...(blob.type.startsWith('image/') && { _blobUrl: URL.createObjectURL(blob) })
          };
        }

        // Track in timeline
        timelineService.trackAPI(
          method,
          url,
          status,
          duration,
          {
            url,
            requestBody: req.body,
            responseBody: responseBody,
            headers: req.headers.keys().reduce((acc, key) => {
              acc[key] = req.headers.get(key);
              return acc;
            }, {} as any)
          }
        );

        // Track in console logs
        loggerService.trackAPICall(method, url, status, duration, {
          requestBody: req.body,
          responseBody: responseBody
        });
      }
    }),
    catchError(error => {
      const duration = Date.now() - startTime;
      const status = error.status || 0;
      
      // Track error in timeline
      timelineService.trackAPI(
        method,
        url,
        status,
        duration,
        {
          url,
          requestBody: req.body,
          error: error.message,
          errorDetails: error.error
        }
      );
      
      // Track error in console logs
      loggerService.trackAPICall(method, url, status, duration, {
        requestBody: req.body,
        error: error.message,
        errorDetails: error.error
      });

      return throwError(() => error);
    })
  );
};
